// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feature-card-container {
    gap: var(--dl-space-space-unit);
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: flex-start;
}
.feature-card-text {
    font-weight: 600;
    line-height: 28px;
    color: #000;
}
@media (max-width: 767px) {
    .feature-card-feature-card {
        flex-direction: row;
    }
    .feature-card-container {
        flex-direction: column;
    }
}
@media (max-width: 479px) {
    .feature-card-container {
        flex-direction: column;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/feature-card.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,sBAAsB;IAC1B;AACJ;AACA;IACI;QACI,sBAAsB;IAC1B;AACJ","sourcesContent":[".feature-card-container {\r\n    gap: var(--dl-space-space-unit);\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n}\r\n.feature-card-text {\r\n    font-weight: 600;\r\n    line-height: 28px;\r\n    color: #000;\r\n}\r\n@media (max-width: 767px) {\r\n    .feature-card-feature-card {\r\n        flex-direction: row;\r\n    }\r\n    .feature-card-container {\r\n        flex-direction: column;\r\n    }\r\n}\r\n@media (max-width: 479px) {\r\n    .feature-card-container {\r\n        flex-direction: column;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
